import React from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from 'semantic-ui/semantic-ui-imports';
import ProjectList from '../../components/ProjectList';
import './index.scss';

const MyPage = () => {
  const { t } = useTranslation();

  return (
    <div className="mypage">
      <Header as="h1" className="mypage__header">
        {t('myPage.title')}
      </Header>
      <ProjectList />
    </div>
  );
};

export default MyPage;
